import { Instance, types } from 'mobx-state-tree'

export const VehicleProfileModel = types.model('VehicleProfileModel', {
    vehicle_id: types.identifierNumber,
    installed_profile_id: types.maybeNull(types.string),
    // Id of the vehicle's latest profile update request (see ProfileUpdateRequestModel)
    update_request_id: types.maybeNull(types.number),
})

export type VehicleProfile = Instance<typeof VehicleProfileModel>
